<template>
  <Layout content_class="home">
    <PageHeader :title="title" :items="items" />
    <div class="container mb-4">
      <div class="row pt-4 pb-4">
        <div class="col-md-12 text-center mx-auto title-home h6"
          ><b>Bienvenid@s a nuestro Sistema Caracterización 360</b></div
        >
        <div
          class="
            mx-auto
            col-md-8 col-lg-10 col-xs-12
            mt-2
            subtitle-home
            d-none d-sm-block
          "
          >El Sistema Caracterización 360 permite la visión integral del ciudadano por
          medio de la creación y administración de variables y formularios de
          forma dinámica.</div
        >
      </div>
      <div class="content-list-card" v-if="Object.keys(routes || []).length > 0">
        <div
          class="list-card"
          v-for="(item, index) in records"
          :key="index"
        >
          <!-- card component -->
          <card-home v-if="item && routes.includes(item.path)" :record="item" />
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import CardHome from './components/CardHome'
import Network from '@plugins/Network'
import { encrypt, decrypt } from '@/src/utils/local-storage'

export default {
  page: {
    title: 'Inicio',
    meta: [{ name: 'description', content: getSecret('DESCRIPTION') }],
  },
  components: { Layout, PageHeader, Network, CardHome },
  data() {
    return {
      title: '',
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
      ],
      routes: ['home'],
      currentSession: this.$store.state.auth.currentSession.user,
      dimensions_cached: '' || [],
      forms_cached: '' || [],
      records: [
        {
          icon: require("@assets/images/variables.svg"),
          title: "Variables",
          path: "/variables",
          items: [
            {
              nameRoute: "variables",
              title: "Creación Variables"
            },
            {
              nameRoute: "variablesList",
              title: "Listado de Variables"
            }
          ]
        },
        {
          icon: require("@assets/images/formularios.svg"),
          title: "Formularios",
          path: "/lista-formularios",
          items: [
            {
              nameRoute: "formFillList",
              title: "Diligenciar Formularios"
            },
            {
              nameRoute: "forms",
              title: "Crear Formularios"
            },
            {
              nameRoute: "formList",
              title: "Listar Formularios"
            }
          ]
        },
        {
          icon: require("@assets/images/encuestas.svg"),
          title: "Encuestas",
          path: "/lista-encuestas",
          items: [
            {
              nameRoute: "pollFillList",
              title: "Diligenciar Encuestas"
            },
            {
              nameRoute: "poll",
              title: "Crear Encuestas"
            },
            {
              nameRoute: "pollList",
              title: "Listar Encuestas"
            }
          ]
        },
        {
          icon: require("@assets/images/reportes.svg"),
          title: "Informes y Reportes",
          path: "/informe-lista-ciudadano",
          items: [
            {
              nameRoute: "citizenReport",
              title: "Informe Caracterización Ciudadano"
            },
            {
              nameRoute: "logsReport",
              title: "Informe Logs"
            },
            {
              nameRoute: "homeReport",
              title: "Informe Hogares"
            },
            {
              nameRoute: "citizenListReport",
              title: "Lista Ciudadanos"
            }
          ]
        },
      ]
    }
  },
  mounted() {
    this.dimensions_cached = this.getSavedState('dimensions_cached')
    this.forms_cached = this.getSavedState('forms_cached')
    this.$nextTick(() => {
      this.getAllowedRoutes(this.currentSession.app_sections_tree)
    })
  },
  methods: {
    getSavedState(key) {
      key =
        JSON.parse(this.getStateLocalStorage('auth.currentSession')).user
          .username +
        '.' +
        key
      let retorno = JSON.parse(this.getStateLocalStorage(key))
      return retorno
    },
    getStateLocalStorage(key) {
      let storage = window.localStorage.getItem(key)
      if (storage != null) {
        if (typeof storage == Object && storage.length < 0) {
          return '[]'
        }
        return decrypt(storage)
      } else {
        return '[]'
      }
    },
    getAllowedRoutes(sections, incoming_routes = []) {
      let routes = this.routes ? this.routes : incoming_routes
      this.routes = routes
      let context = this
      sections.forEach(function(x) {
        if (x.hasOwnProperty('children')) {
          context.getAllowedRoutes(x.children, routes)
        } else {
          if (x.path !== null) {
            context.routes.push(x.path)
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
.content-list-card {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

.rounded-5 {
  border-radius: 10px;
}

.card-button:hover {
  -webkit-transform: scale(1.15);
  transform: scale(1.15);
  transition: all 0.35s;
}

.text {
  text-align: center;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.title-home {
  font-family: 'Montserrat';
  font-weight: bold;
  font-size: 18px;
}

.subtitle-home {
  font-family: 'Work Sans', sans-serif;
  text-align: center;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-weight: 400;
}

@media screen and (max-width: 767.98px) {
  .content:before {
    width: 100% !important;
  }

  .card-button {
    width: 150px;
    height: 150px;

    img {
      margin-bottom: 4px !important;
    }
  }
}


@media screen and (min-width: 767.99px) {
  .content:before {
    width: calc(100% - 240px) !important;
    margin-left: 240px;
  }

  .card-button {
    width: 13rem;
    height: 140px;
    border-radius: 6%;
  }
}

@media screen and (min-width: 1199px) {
  .card-button {
    height: 218px;
    width: 218px;
  }
}

</style>
